import { ApiError, authApi } from '@/api/client';
import { authStorage } from './auth';
import { clearBannedState, markUserBanned } from './bannedSession';
import { getTelegramWebApp } from './telegram';

export async function initAuth(): Promise<void> {
  const tg = getTelegramWebApp();
  const initData = tg.initData;

  if (!initData || initData === 'mock_init_data') {
    console.warn('[auth] no real initData — skipping login');
    return;
  }

  // Всегда логинимся при старте Mini App.
  // Telegram выпускает свежий initData при каждом открытии — это наш source of truth.
  // localStorage используется только для передачи токена между запросами в рамках сессии.
  try {
    const { token, user } = await authApi.loginWithTelegram(initData);
    clearBannedState();
    authStorage.setToken(token);
    authStorage.setUser(user);
    console.info(`[auth] logged in as ${user.display_name} (@${user.telegram_username})`);
  } catch (err) {
    if (err instanceof ApiError && (err.code === 'USER_BANNED' || err.message === 'Your account is banned')) {
      markUserBanned();
      console.warn('[auth] account is banned');
      return;
    }
    console.error('[auth] login failed:', err);
    authStorage.clear();
  }
}
